import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IDeleteDocumentInterventionResponse from 'services/httpClient/responses/intervention/IDeleteDocumentInterventionResponse';

import { interventionActions } from '../index';
import { IDeleteDocumentInterventionRequestAction } from '../reducers/deleteDocument/request';

interface IDeleteDocumentInterventionParams {
  intervention_document_id: number;
}

function* deleteDocument(
  action: PayloadAction<IDeleteDocumentInterventionRequestAction>,
) {
  const { file_type, id, intervention_document_id } = action.payload.data;
  try {
    const params: IDeleteDocumentInterventionParams = {
      intervention_document_id,
    };
    const response: AxiosResponse<IDeleteDocumentInterventionResponse> =
      yield call(rikHttpClient.delete, `interventions/${id}/document`, {
        params,
      });

    yield put(
      interventionActions.deleteDocumentSuccess({
        document: {
          deleted: response.data,
          intervention_document_id,
          file_type,
        },
      }),
    );
    action.payload.functions.close();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.deleteDocumentFailure());
  }
}

export default deleteDocument;
